// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// reportWebVitals();




// import React from "react";
// import ReactDOM from "react-dom/client";
// import { HelmetProvider } from "react-helmet-async";
// import App from "./App";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <HelmetProvider>
//     <App />
//   </HelmetProvider>
// );

import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "./styles/theme.css";
import reportWebVitals from "./reportWebVitals";


// ✅ Import HelmetProvider
import { HelmetProvider } from "react-helmet-async";

const container = document.getElementById("root");
const isProduction = process.env.NODE_ENV === "production";

const app = (
  <React.StrictMode>
    {/* ✅ Wrap your entire app in HelmetProvider */}
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Only hydrate against prerendered production markup.
// In development, CRA serves public/index.html, which should be client-rendered.
if (isProduction && container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

reportWebVitals();

